import * as E from 'fp-ts/Either';
import { filterOrElseW } from 'fp-ts/Either';
export var fromLeftToRight = function fromLeftToRight(ref, fn) {
  return E.orElseW(function (l) {
    return ref(l) ? E.right(fn(l)) : E.left(l);
  });
};
export var filterOrNarrowElseW = filterOrElseW;